import {Form as MobxReactForm} from 'utils/mobx-react-form';
import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';

const plugins = {dvr: dvr(validatorjs)};

const fields = [
  {
    name: 'oldPassword',
    rules: 'required|string',
    label: 'old password'
  },
  {
    name: 'newPassword',
    rules: 'required|string',
    label: 'new password'
  },
  {
    name: 'newPasswordConfirm',
    rules: 'required|string',
    label: 'new password confirmation'
  }
];

export const createLocalisedForm = translations => new MobxReactForm({fields}, {plugins});
export default new MobxReactForm({fields}, {plugins});
